$shm_wordstat_filter_panel $shm_service_filter_panel
	state null $shm_wordstat_filter_state_store
	queries? \
	queries_blur? null
	query_filter? *
	query_available /
	query_limit 200
	regions? \
	period_kind? \PERIOD_DAILY
	period_kinds? *
	period_kind_available /
	devices? *
	device_available /
	period? *
		from \
		to \
	period_all *
		from \0001-01-01
		to \2999-12-31
	period_all_kind* <= period_all
	collecting true
	query_visible true
	period_kind_visible true
	device_visible true
	region_visible true
	region_available /
	run_enabled true
	run_title \Собрать
	cancel_visible false
	title <= panel_title \Фильтры
	reset? <=> filter_reset? null
	filter_reset? null
	body /
		<= Filters $mol_list
			rows <= filter_rows /
				<= Period_section $shm_wordstat_filter_section
					title_content /
						<= Period_icon $mol_icon_calendar
					Expand null
					content /
						<= Period $shm_ba_date
							period? <=> period?
							period_all <= period_all
				<= Period_kind_section $shm_wordstat_filter_section
					title \Периодичность
					Expand null
					content /
						<= Period_kinds $mol_view
							sub <= period_kind_check_rows /
								<= Period_kind_check*0 $mol_check_box
									title <= period_kind_title* \
									checked? <=> period_kind_checked*? false
									enabled <= period_kind_enabled* true
								<= Period_kind_radio*0 $shm_radio
									title <= period_kind_title* \
									checked? <=> period_kind_checked*? false
									enabled <= period_kind_enabled* true
				<= Query_section $shm_wordstat_filter_section
					title_content <= query_title_content /
						<= Query_title $mol_view
							sub / \Запросы
						<= Query_hint $mol_view
							sub / <= query_hint \Каждый запрос с новой строки
						<= Query_all $shm_check_all
							checks <= query_group_checks /
							title \Все
					Expand null
					content <= query_content /
						<= Queries $mol_textarea
							hint \Каждый запрос с новой строки
							value? <=> queries?
							event *
								^
								focusout? <=> queries_blur?
						<= Query_checks $mol_view
							sub <= query_check_rows /
								<= Query_row*0 $mol_view
									sub <= query_row_content*0 /
				<= Devices_section $shm_wordstat_filter_section
					title_content /
						<= Device_title $mol_view
							sub / \Устройства
						<= Device_group_all $shm_check_all
							checks <= device_group_checks /
							title \Все
					Expand null
					content /
						<= Devices $mol_view
							sub /
								<= Device_all $mol_check_box
									title \Все
									checked? <=> device_all? true
									enabled <= device_all_enabled true
								<= Device_desktop $mol_check_box
									title \ПК
									checked? <=> device_desktop? false
									enabled <= device_desktop_enabled true
								<= Device_phone $mol_check_box
									title \Телефоны
									checked? <=> device_phone? false
									enabled <= device_phone_enabled true
								<= Device_tablet $mol_check_box
									title \Планшеты
									checked? <=> device_tablet? false
									enabled <= device_tablet_enabled true
				<= Region_select $shm_wordstat_region_select
					regions? <=> regions?
					allowed_ids <= region_available /
					presets_visible true
	foot <= foot_rows /
		<= Run $mol_button_major
			enabled <= run_enabled
			title <= run_title
			click? <=> run? null
	Query_check*0 $mol_check_box
		title <= query_title* \
		checked? <=> query_checked*? true
	Query_only*0 $mol_button_minor
		title \Только
		click? <=> query_only*? null
